import React from 'react';
import moment from 'moment';
import './AppointmentModal.css';

const AppointmentModal = ({ appointment, onClose }) => {
  if (!appointment) return null;

  const {
    slot_start_time,
    slot_end_time,
    doctor_first_name,
    doctor_last_name,
    patient_first_name,
    patient_last_name,
    status,
    subjective,
    objective,
    assessment,
    plan,
    other,
  } = appointment;

  // Convert UTC time to local time
  const startMoment = moment.parseZone(slot_start_time).local();
  const endMoment = moment.parseZone(slot_end_time).local();

  const appointmentDate = startMoment.format("YYYY-MM-DD");
  const appointmentTime = `${startMoment.format("HH:mm")} - ${endMoment.format("HH:mm")}`;

  const practitionerName = `${doctor_first_name || ''} ${doctor_last_name || ''}`.trim();
  const patientName = `${patient_first_name || ''} ${patient_last_name || ''}`.trim();

  const statusLabelMap = {
    BO: "Booked",
    AP: "Approved",
    CO: "Completed",
    CA: "Cancelled",
    PC: "Payment Completed",
    PW: "Payment Completed Without Doctor Completed",
  };

  const readableStatus = statusLabelMap[status] || status || 'N/A';

  // Parsing treatment summary
  let treatmentSummary = {};
  try {
    treatmentSummary = other ? JSON.parse(other) : {};
  } catch (e) {
    treatmentSummary = {};
  }

  return (
    <div className="pat-timeline-modal-overlay">
      <div className="pat-timeline-modal-content">
        <button className="pat-timeline-close-btn" onClick={onClose}>×</button>

        <h3 className="pat-timeline-modal-header">Appointment Details</h3>

        <div className="pat-modal-section">
          <div className="pat-modal-row">
            <span className="pat-modal-label">Date:</span>
            <span className="pat-modal-value">{appointmentDate}</span>
          </div>
          <div className="pat-modal-row">
            <span className="pat-modal-label">Time:</span>
            <span className="pat-modal-value">{appointmentTime}</span>
          </div>
          <div className="pat-modal-row">
            <span className="pat-modal-label">Patient:</span>
            <span className="pat-modal-value">{patientName || 'N/A'}</span>
          </div>
          <div className="pat-modal-row">
            <span className="pat-modal-label">Practitioner:</span>
            <span className="pat-modal-value">{practitionerName || 'N/A'}</span>
          </div>
          <div className="pat-modal-row">
            <span className="pat-modal-label">Status:</span>
            <span className="pat-modal-value">{readableStatus}</span>
          </div>
        </div>

        <div className="pat-modal-split">
          <div className="pat-modal-box">
            <h4 className="pat-modal-subheader">SOAP Notes</h4>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Subjective:</span>
              <span className={`pat-modal-value ${subjective && subjective.length < 60 ? 'single-line' : ''}`}>{subjective || 'N/A'}</span>
            </div>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Objective:</span>
              <span className={`pat-modal-value ${objective && objective.length < 60 ? 'single-line' : ''}`}>{objective || 'N/A'}</span>
            </div>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Assessment:</span>
              <span className={`pat-modal-value ${assessment && assessment.length < 60 ? 'single-line' : ''}`}>{assessment || 'N/A'}</span>
            </div>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Plan:</span>
              <span className={`pat-modal-value ${plan && plan.length < 60 ? 'single-line' : ''}`}>{plan || 'N/A'}</span>
            </div>
          </div>

          <div className="pat-modal-box">
            <h4 className="pat-modal-subheader">Treatment Summary</h4>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Duration:</span>
              <span className="pat-modal-value">{treatmentSummary.duration_of_massage || 'N/A'}</span>
            </div>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Techniques Used:</span>
              <span className={`pat-modal-value ${treatmentSummary.techniques_used?.length < 60 ? 'single-line' : ''}`}>
                {treatmentSummary.techniques_used || 'N/A'}
              </span>
            </div>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Comments:</span>
              <span className={`pat-modal-value ${treatmentSummary.comments?.length < 60 ? 'single-line' : ''}`}>
                {treatmentSummary.comments || 'N/A'}
              </span>
            </div>
            <div className="pat-modal-row">
              <span className="pat-modal-label">Self-Care:</span>
              <span className={`pat-modal-value ${treatmentSummary.self_care_recommendations?.length < 60 ? 'single-line' : ''}`}>
                {treatmentSummary.self_care_recommendations || 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentModal;
